// Time constants for duration calculations
export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;
export const SECONDS_IN_DAY = SECONDS_IN_HOUR * 24;
export const SECONDS_IN_WEEK = SECONDS_IN_DAY * 7;
export const SECONDS_IN_YEAR = SECONDS_IN_DAY * 365;

// Minimum stake duration is one week
export const MIN_DURATION_SECONDS = SECONDS_IN_WEEK;
